import Identification, { IdentificationSections } from './Identification';

export default Identification;
export { IdentificationSections };
